//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import loginMutation from '~/queries/login.graphql';
import registerMutation from '~/queries/register.graphql';
import { validateEmail, validatePassword } from '@/plugins/validator';
import canonicalUrls from '~/mixins/canonicalUrls';

export default {
    props: [],
    layout: 'minimal',
    middleware: 'guest',
    mixins: [canonicalUrls],
    data() {
        return {
            error: '',
            form: {
                firstname: '',
                lastname: '',
                email: '',
                password: '',
                passwordConfirm: '',
            },
            tagType: 'h2',
        };
    },
    methods: {
        async login() {
            this.error = '';

            try {
                if (this.form.password !== this.form.passwordConfirm) {
                    this.$notify.error(this.$t('account.nav.createaccount.passwordsnotmatch'));
                    throw Error(this.$t('account.nav.createaccount.passwordsnotmatch'));
                }

                if (!validatePassword(this.form.password)) {
                    this.$notify.error(this.$t('account.user.invalidpassword'));
                    throw Error(this.$t('account.user.invalidpassword'));
                }

                if (!this.form.email || !validateEmail(this.form.email)) {
                    this.$notify.error(this.$t('account.user.invalidemail'));
                    throw Error(this.$t('account.user.invalidemail'));
                }

                const variables = this.form;
                delete variables.passwordConfirm;
                await this.$apollo.mutate({
                    mutation: registerMutation,
                    variables: { input: variables },
                });
                const res = await this.$apollo
                    .mutate({
                        mutation: loginMutation,
                        variables,
                    })
                    .then(({ data }) => data && data.generateCustomerToken);
                await this.$apolloHelpers.onLogin(res.token);
                let oldCartId = this.$storage.getCookie('cart_id');
                await this.$auth.getUser();
                await this.$store.dispatch('cart/mergeCarts', oldCartId);
                await this.$store.dispatch('wishlist/getWishlist');
                await this.$router.push(this.$store.state.redirect.loginCallBack ?? '/');
            } catch (e) {
                this.error = e;
                console.error(e);
            }
        },
    },
    mounted() {
        if (process.client) {
            this.tagType = document.querySelectorAll('h1').length ? 'h2' : 'h1';
        }
    },
    head() {
        return {
            title: this.$t('account.createaccountpage.createaccount'),
            meta: [
                {
                    hid: 'og:title',
                    name: 'og:title',
                    content: this.$t('account.createaccountpage.createaccount'),
                },
            ],
            link: this.head.link,
        };
    },
};
